module.exports = __webpack_public_path__ + "img/Group 10068.e86a6cce.svg";